import React, { useContext } from 'react';
import { Row, Col } from 'reactstrap';
import { SearchResultCategory } from './components/Category';

import { Title, ClearSearch } from './styles';
import FaqContext from '../../../../contexts/FAQContext';

export const SearchList = props => {
  const { searchTerm, faq } = useContext(FaqContext);

  const { category } = props;

  const putFocusOnSearchField = () => {
    window.location.href= `#/faq/${category}`;
    const inputField = document.getElementById("search-term");
    inputField.focus();
  };

  const foundResults =
    faq.length > 0 ? faq.reduce((total, item) => total + item.questions.length, 0) : 0;

  return (
    <Row>
      <Col xs="12" className="p-0 my-2">
        <Title tabIndex="-1" role="alert" className="mb-3">
          {foundResults > 0
            ? `Showing ${foundResults} search result${
                foundResults > 1 ? 's' : ''
              } for '${searchTerm}'`
            : `No results found to '${searchTerm}'`}
          <ClearSearch 
            onKeyPress={putFocusOnSearchField}
            onClick={putFocusOnSearchField}>
              <u>Clear Search</u>
          </ClearSearch>
        </Title>
        <Row>
          {faq.map(
            foundCategory =>
              foundCategory.questions.length === 0 || (
                <SearchResultCategory key={foundCategory.key} data={foundCategory} />
              ),
          )}
        </Row>
      </Col>
    </Row>
  );
};
